import React, { useContext } from "react";
import { MenuContext } from "../contexts/MenuContext";
import "./styles/SongDisplayHeader.css";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EditIcon from "@mui/icons-material/Edit";

function SongDisplayHeader() {
  const { setOpenSong } = useContext(MenuContext);
  const closeSong = () => {
    setOpenSong([]);
  };
  return (
    <div className="song--display--header">
      <button className="song--display--back" onClick={closeSong}>
        <ArrowBackIosNewIcon style={{ fill: "#ffffff" }} fontSize="large" />
      </button>
      <button className="song--display--edit">
        <EditIcon style={{ fill: "#ffffff" }} fontSize="large" />
      </button>
    </div>
  );
}

export default SongDisplayHeader;
